import { AlertTriangle } from "lucide-react";

export interface InferenceWarning {
  code?: string;
  columns?: string[];
  message?: string;
  [key: string]: unknown;
}

export interface WarningsBannerProps {
  warnings: InferenceWarning[] | null | undefined;
}

function renderWarning(w: InferenceWarning, idx: number): React.ReactNode {
  if (w.code === "unknown_feature_columns" && Array.isArray(w.columns)) {
    return (
      <li key={idx}>
        Unknown columns supplied: <span className="font-mono">{w.columns.join(", ")}</span>
      </li>
    );
  }
  if (w.code === "missing_known_covariates") {
    return (
      <li key={idx}>
        Covariates expected but not supplied — prediction quality may degrade.
        {w.message ? (
          <span className="block text-[11px] text-amber-900/80 mt-0.5">{w.message}</span>
        ) : null}
      </li>
    );
  }
  const text = w.message ?? (w.code ? `Warning: ${w.code}` : "Warning");
  return <li key={idx}>{text}</li>;
}

export function WarningsBanner({ warnings }: WarningsBannerProps) {
  if (!warnings || warnings.length === 0) return null;
  return (
    <div
      role="alert"
      className="mb-3 flex items-start gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-900"
    >
      <AlertTriangle size={14} className="mt-0.5 flex-none" />
      <ul className="list-disc pl-4 space-y-0.5">{warnings.map(renderWarning)}</ul>
    </div>
  );
}
